/* import __COLOCATED_TEMPLATE__ from './-subsection.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();